var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.points.length > 0)?_c('div',{ref:"heatmap",style:(`width: ${_vm.mapWidth}; height: ${_vm.mapHeight}`)}):_c('p',{staticClass:"msg-not-sector"},[_vm._v("NO HAY PUNTOS PARA MOSTRAR")])
}
var staticRenderFns = []

export { render, staticRenderFns }